if (!customElements.get('order-status-form')) {
  class OrderStatusForm extends HTMLElement {
    connectedCallback() {
      this.addEventListener('submit', e => {
        e.preventDefault();
        this.orderNumber = this.querySelector('[name="order_number"]')?.value;
        this._setLoading(true);
        this.checkOrder();
      });
    }

    _setLoading(loading) {
      const btn = this.querySelector('button[type="submit"]');
      if (!btn) return;
      btn.disabled = loading;
      this.querySelector('.js-btn-label')?.classList.toggle('hidden', loading);
      this.querySelector('.js-btn-loading')?.classList.toggle('hidden', !loading);
    }

    async checkOrder() {
      fetch(`https://47.sparkyapps.dev/shopify/orders/name?order_name=${this.orderNumber}`, {
        method: 'GET',
      })
        .then(r => r.json())
        .then(order => {
          const orderCreatedAt = order.order?.createdAt;
          const shippingZipCode = order.order?.shippingAddress?.zip;
          let narvarTrackUrl;

          if (order.order?.fulfillments.length > 0) {
            const fulfillmentCreatedAt = order.order?.fulfillments?.[0].createdAt;
            const fulfillmentTrackingCode = order.order?.fulfillments?.[0].trackingInfo?.[0].company;
            const fulfillmentTrackingNumber = order.order?.fulfillments?.[0].trackingInfo?.[0].number;
            narvarTrackUrl = `https://47brand.narvar.com/47brand/tracking/${fulfillmentTrackingCode}?tracking_numbers=${fulfillmentTrackingNumber}&order_number=${this.orderNumber}&ozip=02301&dzip=${shippingZipCode}&order_date=${orderCreatedAt}&ship_date=${fulfillmentCreatedAt}`;
          } else {
            narvarTrackUrl = `https://47brand.narvar.com/47brand/tracking/order_number=${this.orderNumber}&ozip=02301&dzip=${shippingZipCode}&order_date=${orderCreatedAt}`;
          }
          window.open(narvarTrackUrl, 'mozillaTab');
          this._setLoading(false);
        })
        .catch(err => {
          console.error(err);
          this._setLoading(false);
          const details = this.querySelector('[data-order-details]');
          if (details) details.textContent = 'Unable to fetch tracking information. Double check your order number, refresh and try again.';
        });
    }
  }
  customElements.define('order-status-form', OrderStatusForm);
}
